import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Snackbar,
  Alert
} from '@mui/material';
import { addMentorPrice, editMentorPrice } from '../../services';

const AddPrice = ({ open, onClose, onSubmit, selectedMentorPriceId, selectedMentorPrice, dialogMode }) => {
  console.log("mode", dialogMode);

  const [formData, setFormData] = useState({
    price: '',
    label: '',
    duration: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (dialogMode === 'edit' && selectedMentorPrice) {
      setFormData({
        price: selectedMentorPrice.price || '',
        label: selectedMentorPrice.label || '',
        duration: selectedMentorPrice.duration || ''
      });
    } else if (dialogMode === 'add') {
      setFormData({
        price: '',
        label: '',
        duration: ''
      });
    }
  }, [selectedMentorPrice, dialogMode]);

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
const handleSave = async () => {
  let data = {
    ...formData,
    mentor_id: selectedMentorPriceId,
  };

  // Add ID to data if editing
  if (dialogMode === 'edit') {
    data.mentor_price_id = selectedMentorPrice.id;
  }

  try {
    let response;

    if (dialogMode === 'edit') {
      response = await editMentorPrice(data); // ⬅️ only data passed
    } else {
      response = await addMentorPrice(data);
    }

    if (response.status === 200) {
      onClose();
      onSubmit();
      setFormData({
        price: '',
        label: '',
        duration: '',
      });
      setSnackbar({
        open: true,
        message: dialogMode === 'edit' ? "Price Updated Successfully!" : "Price Added Successfully!",
        severity: "success",
      });
    }
  } catch (err) {
    setSnackbar({
      open: true,
      message: err?.response?.data?.message || "Something went wrong. Please try again.",
      severity: "error",
    });
  }
};

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{dialogMode === 'edit' ? 'Edit Time Slot' : 'Add Time Slot'}</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Price"
            value={formData.price}
            onChange={handleChange('price')}
            fullWidth
            type="number"
          />
          <TextField
            label="Label"
            select
            value={formData.label}
            onChange={handleChange('label')}
            fullWidth
          >
            {/* <MenuItem value="Chat">Chat</MenuItem> */}
            <MenuItem value="Vedio">Vedio</MenuItem>
          
          </TextField>
          <TextField
            label="Duration"
            select
            value={formData.duration}
            onChange={handleChange('duration')}
            fullWidth
          >
            <MenuItem value="30">30 min</MenuItem>
            <MenuItem value="45">45 min</MenuItem>
            <MenuItem value="60">60 min</MenuItem>
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddPrice;
